var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeleteAudience = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 3.99998H14.6667V5.33331H13.3334V14C13.3334 14.1768 13.2631 14.3464 13.1381 14.4714C13.0131 14.5964 12.8435 14.6666 12.6667 14.6666H3.33337C3.15656 14.6666 2.98699 14.5964 2.86197 14.4714C2.73695 14.3464 2.66671 14.1768 2.66671 14V5.33331H1.33337V3.99998H4.66671V1.99998C4.66671 1.82317 4.73695 1.6536 4.86197 1.52858C4.98699 1.40355 5.15656 1.33331 5.33337 1.33331H10.6667C10.8435 1.33331 11.0131 1.40355 11.1381 1.52858C11.2631 1.6536 11.3334 1.82317 11.3334 1.99998V3.99998ZM12 5.33331H4.00004V13.3333H12V5.33331ZM6.00004 7.33331H7.33337V11.3333H6.00004V7.33331ZM8.66671 7.33331H10V11.3333H8.66671V7.33331ZM6.00004 2.66665V3.99998H10V2.66665H6.00004Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteAudience, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deleteAudience.4e5e8b39.svg";
export { ForwardRef as ReactComponent };